import Attributes_AttributesPage from "@Alternatives/Attributes/Pages/AttributesPage.vue";

export const routes = [
    {
        path: "/pp/attributes/:workspaceId/:projectId/:include?",
        component: Attributes_AttributesPage
    },
]
